import { useEffect, useRef, useState } from 'react';
import { EllipsisVerticalIcon } from 'lucide-react';
import { Box, IconButton, Menu, useToken } from '@chakra-ui/react';

type Props = {
  onAddResult: () => void;
};

export const LabOrderMenu = ({ onAddResult }: Props) => {
  const [steel] = useToken('colors', ['steel']);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [openUpward, setOpenUpward] = useState(false);

  // Estimated height of the menu content, used to decide whether it fits
  // below the trigger before the actual content is measured.
  const ESTIMATED_MENU_HEIGHT = 60;

  useEffect(() => {
    if (!isOpen || !containerRef.current) return;

    const { bottom } = containerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - bottom;
    setOpenUpward(spaceBelow < ESTIMATED_MENU_HEIGHT);
  }, [isOpen]);

  return (
    <Box
      ref={containerRef}
      position={'relative'}
      zIndex={isOpen ? 1 : 'auto'}
      onClick={(e) => e.stopPropagation()}
    >
      <Menu.Root open={isOpen} onOpenChange={(details) => setIsOpen(details.open)}>
        <Menu.Trigger asChild>
          <IconButton variant={'ghost'} size={'sm'} aria-label={'Lab order actions'}>
            <EllipsisVerticalIcon color={steel} size={16} />
          </IconButton>
        </Menu.Trigger>
        <Menu.Positioner
          style={
            {
              position: 'absolute',
              bottom: openUpward ? '100%' : 'auto',
              top: openUpward ? 'auto' : '100%',
              right: 0,
              left: 'auto',
              marginTop: '8px',
              marginBottom: '8px',
              transform: 'none',
            } as const
          }
        >
          <Menu.Content>
            <Menu.Item
              fontSize={'xs'}
              onSelect={onAddResult}
              value="add-result"
              _highlighted={{ bg: 'mint' }}
            >
              Add result
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
    </Box>
  );
};

export default LabOrderMenu;
